const media = "(prefers-reduced-motion: reduce)";
const pref = window.matchMedia(media);

jQuery(document).ready(function($) {

  if($('.wf-laptop-photo').length) {

    $(window).scroll(function() {
      $('.wf-laptop-photo').each(function() {
        if(isScrolledIntoView($(this)[0]) && !$(this).hasClass('show')) {
          $(this).addClass('show')
        }
      });
    });

  }

  if($('.wf-icon-set-title').length) {

    $(window).scroll(function() {
      $('.wf-icon-set-title').each(function() {
        if(isScrolledIntoView($(this)[0]) && !$(this).hasClass('show')) {
          $(this).addClass('show')
        }
      });
    });

  }

  if($('.wf-icon-set').length) {

    $(window).scroll(function() {
      $('.wf-icon-set').each(function() {
        if(isScrolledIntoView($(this)[0]) && !$(this).hasClass('show')) {
          $(this).addClass('show')
        }
      });
    });

  }

  if($('.wp-block-group.technologies-new-2').length) {

    $(window).scroll(function() {
      if(isScrolledIntoView('.wp-block-group.technologies-new-2 .wf-view') && !$('.wp-block-group.technologies-new-2').hasClass('show')) {
        $('.wp-block-group.technologies-new-2').addClass('show')
      }
    });

  }

  if($('.wp-block-group.technologies-2').length) {

    $(window).scroll(function() {
      if(isScrolledIntoView('.wp-block-group.technologies-2') && !$('.wp-block-group.technologies-2').hasClass('show')) {
        $('.wp-block-group.technologies-2').addClass('show')
      }
    });

  }

  if($('.wp-block-group.technologies-4').length) {

    $(window).scroll(function() {
      if(isScrolledIntoView('.wp-block-group.technologies-4') && !$('.wp-block-group.technologies-4').hasClass('show')) {
        $('.wp-block-group.technologies-4').addClass('show')
      }
    });

  }

  if($('.wp-block-group.technologies-7').length) {

    $(window).scroll(function() {
      if(isScrolledIntoView('.wp-block-group.technologies-7') && !$('.wp-block-group.technologies-7').hasClass('show')) {
        $('.wp-block-group.technologies-7').addClass('show')
      }
    });

  }

  //$('.wf-slider .slick-dots').removeAttr('tablist');

  $('.carousel-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    focusOnSelect: true,

    prevArrow: "<button type='button' class='slick-prev'><img src='/wp-content/themes/JointsWP-master/assets/images/arrow-left.svg'></button>",
    nextArrow: "<button type='button' class='slick-next'><img src='/wp-content/themes/JointsWP-master/assets/images/arrow-right.svg'></button>",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
      }
    ]
  });

  $('.carousel-slider .slick-dots').removeAttr('tablist');

  if($('.wp-block-column.has-red-stripe-right, .wp-block-group.has-red-stripe-right')) {
    $('.wp-block-column.has-red-stripe-right, .wp-block-group.has-red-stripe-right').each(function() {
      $(this).append('<span class="redstripe"></span>');
    });
  }

  if($('.wp-block-column.has-red-stripe-left, .wp-block-group.has-red-stripe-left')) {
    $('.wp-block-column.has-red-stripe-left, .wp-block-group.has-red-stripe-left').each(function() {
      $(this).append('<span class="redstripe"></span>');
    });
  }

  if($('.wf-logo-images-block')) {
    $('.wf-logo-images-block').each(function() {
      $(this).append('<span class="redstripe"></span>');
    });
  }

  if($('.wp-block-cover.page-header .wp-block-cover__inner-container')) {
    $('.wp-block-cover.page-header .wp-block-cover__inner-container').each(function() {
      $(this).append('<span class="redstripe"></span>');
    });
  }

  if($('.wp-block-group.technologies-1 .wp-block-group__inner-container')) {
    $('.wp-block-group.technologies-1 .wp-block-group__inner-container').each(function() {
      $(this).append('<span class="redstripe"></span>');
    });
  }

  if($('.wp-block-group.technologies-2 .wp-block-group__inner-container')) {
    $('.wp-block-group.technologies-2 .wp-block-group__inner-container').each(function() {
      $(this).append('<span class="tech-phone-vector"><span class="tech-phones"></span><span class="tech-vector"></span></span>');
    });
  }

  if($('.wp-block-group.technologies-3 .wp-block-group__inner-container')) {
    $('.wp-block-group.technologies-3 .wp-block-group__inner-container').each(function() {
      $(this).append('<span class="redstripe"></span>');
    });
  }


  if($('.wp-block-group.technologies-5')) {
    $('.wp-block-group.technologies-5').each(function() {
      $(this).append('<span class="bg-training jarallax"></span>');
    });
  }

  if($('.wp-block-group.technologies-6')) {
    $('.wp-block-group.technologies-6').each(function() {
      $(this).append('<span class="bg-map jarallax"></span>');
    });
  }

  // Parallax if no reduced motion settings are present
  if (!pref.matches) {
    // console.log('yeet');
    $('.parallax-container .wp-block-image').addClass('jarallax');
    $('.parallax-container .wp-block-image img').addClass('jarallax-img');

    $('.jarallax').jarallax({
      speed: 0.9
    });

    redStripeParallax();
    pageHeaderParallax();
    $(window).scroll(function() {
      redStripeParallax();
      pageHeaderParallax();
    });
  }

  function redStripeParallax() {
    var wHeight = $(window).height();
    var scrollTop = $(window).scrollTop();
    $('.redstripe').each(function() {

      var parallaxDivPosition = $(this).offset().top;
      var parallaxHeight = $(this).outerHeight();
      var parallaxTop = parallaxDivPosition - wHeight;
      var parallaxBottom = parallaxHeight + parallaxDivPosition;

      // if (parallaxTop < 0 && parallaxBottom > 0) {
      if(isInViewport(this)) {
        var parallaxFactor = 50/(wHeight+parallaxHeight);

        var diff = scrollTop - parallaxDivPosition;
        var ratio = Math.round((diff / parallaxHeight) * 100);

        var parallaxposition = parseInt(-(ratio * 1.15));

        $(this).css('-webkit-transform', 'translate3d(0px, '+parallaxposition+'px, 0px)');
        $(this).css('transform', 'translate3d(0px, '+parallaxposition+'px, 0px)');
      }
    });
  }

  function pageHeaderParallax() {
    var wHeight = $(window).height();
    var scrollTop = $(window).scrollTop();
    $('.wp-block-cover.page-header').each(function() {

      var parallaxDivPosition = $(this).offset().top;
      var parallaxHeight = $(this).outerHeight();
      var parallaxTop = parallaxDivPosition - wHeight;
      var parallaxBottom = parallaxHeight + parallaxDivPosition;

      // if (parallaxTop < 0 && parallaxBottom > 0) {
      if(isInViewport(this)) {
        var parallaxFactor = 50/(wHeight+parallaxHeight);

        var diff = scrollTop - parallaxDivPosition;
        var ratio = Math.round((diff / parallaxHeight) * 100);

        var parallaxposition = parseInt((ratio * 0.75));

        $(this).css('background-position', '50% '+parallaxposition+'px');
      }
    });
  }

});
